import * as Phaser from "phaser";

export class ImageButton extends Phaser.GameObjects.Container {
  private buttonImage: Phaser.GameObjects.Image;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    frame?: string,
    onClickCallback?: () => void,
  ) {
    super(scene, x, y);

    // Создаем изображение из текстуры
    this.buttonImage = scene.add.image(0, 0, texture, frame);
    this.buttonImage.setOrigin(0.5);
    this.add(this.buttonImage);

    // Устанавливаем размер интерактивной зоны на основе размера изображения
    this.setSize(this.buttonImage.width, this.buttonImage.height);
    this.setInteractive({ useHandCursor: true });

    // Добавляем обработчики событий
    this.on("pointerover", () => this.onHover());
    this.on("pointerout", () => this.onOut());

    // Добавляем контейнер в сцену
    scene.add.existing(this);

    if (onClickCallback) {
      this.on("pointerdown", onClickCallback);
    }
  }

  private onHover(): void {
    // Останавливаем предыдущие твины
    this.scene.tweens.killTweensOf(this);

    // Анимация увеличения и вращения
    this.scene.tweens.add({
      targets: this,
      scaleX: 1.08,
      scaleY: 1.08,
      angle: Math.random() * 5 - 2.5,
      duration: 200,
      ease: "Power2",
    });
  }

  private onOut(): void {
    // Останавливаем предыдущие твины
    this.scene.tweens.killTweensOf(this);

    // Анимация возврата к исходному состоянию
    this.scene.tweens.add({
      targets: this,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      duration: 200,
      ease: "Power2",
    });
  }
}
